import React, {
    forwardRef,
    useCallback,
    useEffect,
    useImperativeHandle,
    useMemo,
    useState,
} from "react";
import { GridRowModes } from "@mui/x-data-grid";
import { newRow } from "./constants";
import { AGridColDef } from "views/pages/manage/common/data-grid/ADataGridColDef";
import ADataGrid from "views/pages/manage/common/data-grid/EnhanceDataGrid";
import { saveOrDeleteMsg } from "views/pages/manage/edpOps/stockManagement/mastersAndMapping/sapProfitCostCentreMapping/constant";
import { gridStyles } from "views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import { isObjEmpty } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { generateRandomId } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import { Tooltip } from "@mui/material";
import { failureToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";
import CustomChip from "views/pages/manage/common/customChip/CustomChip";
import { regex } from "views/pages/manage/common/constant/regex/index";
import StatusCellComponent from 'views/pages/manage/masters/studentFinancials/paymentCollectionSetup/securityDepositSequencing/StatusCellComponent.jsx';
import { getStatusStyles } from 'modules/studentTransfer/transferSetup/transferValidationConfig/constant.js'
import { selectStyles, inputStyles } from "modules/studentRefund/thirdPartyBankAccMaster/constants";
import ALoader from "views/pages/manage/common/a-loader";
import moment from "moment";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";

const ListComponent = forwardRef(
    (
        {
            rows,
            isloading,
            setIsLoading,
            nextButtonHandler,
            currentPage = 0,
            rowCount,
            currPageSize,
            viewJsonHandler = () => { },
            retryHandler = () => { }
        },
        ref
    ) => {

        const openInNewTab = useCallback((url) => {
            window.open(window.location.origin + "/#/admin/" + url, "_blank").focus();
        }, []);

        const [rowModesModel, setRowModesModel] = useState({});

        const [rowData, setRowData] = useState(rows);

        useEffect(() => setRowData(rows), [rows]);

        const columns = useMemo(() => [
            new AGridColDef("businessAreaValue", "Business Unit", false)
                .setMinWidth(130)
                .editable(true)
                .setFlex(1)
                .renderCellComponent((params) => (
                    params?.value ? <div><Tooltip title={params?.value}>
                        <div className={`ellipsis-text-container`}>{params?.value}</div>
                    </Tooltip></div> : <div>-</div>
                )),
            new AGridColDef("psid", "PSID", false)
                .setMinWidth(130)
                .editable(true)
                .setFlex(1)
                .renderCellComponent((params) => (
                    params?.value !== null && params?.value !== undefined ?
                        <div><Tooltip title={params?.value}>
                            <div style={{ cursor: "pointer" }} className={`text-primary text-sm`} onClick={() => {
                                openInNewTab(`edp/studentDetails/${params?.value}`);
                            }}>{params?.value}</div>
                        </Tooltip></div> : <div>-</div>
                )),
            new AGridColDef("applicationId", "Application Id", false)
                .setMinWidth(130)
                .editable(true)
                .setFlex(1)
                .renderCellComponent((params) => (
                    params?.value !== null && params?.value !== undefined ?
                        <div><Tooltip title={params?.value}>
                            <div className={`ellipsis-text-container`}>{params?.value}</div>
                        </Tooltip></div> : <div>-</div>
                )),
            new AGridColDef("invoiceNumber", "Invoice Number", false)
                .setMinWidth(130)
                .editable(true)
                .setFlex(1)
                .renderCellComponent((params) => (
                    params?.value !== null && params?.value !== undefined ?
                        <div><Tooltip title={params?.value}>
                            <div className={`ellipsis-text-container`}>{params?.value}</div>
                        </Tooltip></div> : <div>-</div>
                )),
            new AGridColDef("invoiceId", "Invoice Id", false)
                .setMinWidth(150)
                .editable(true)
                .setFlex(1)
                .renderCellComponent((params) => (
                    params?.value !== null && params?.value !== undefined ?
                        <div><Tooltip title={params?.value}>
                            <div className={`ellipsis-text-container`}>{params?.value}</div>
                        </Tooltip></div> : <div>-</div>
                )),
            new AGridColDef("invoiceDate", "Invoice Date", false)
                .setMinWidth(130)
                .editable(true)
                .setFlex(1)
                .renderCellComponent((params) => (
                    params?.value !== null && params?.value !== undefined ?
                        <div><Tooltip title={params?.value}>
                            <div className={`ellipsis-text-container`}>{params?.value}</div>
                        </Tooltip></div> : <div>-</div>
                )),
            new AGridColDef("thirdPartyStatus", "Status", false)
                .setMinWidth(110)
                .setFlex(1)
                .editable(true)
                .renderCellComponent((params) => (
                    <CustomChip
                        text={params?.value}
                        textColor={getStatusStyles(params?.value)?.textColor}
                        bgColor={getStatusStyles(params?.value)?.bgColor}
                    />
                )),
            new AGridColDef("viewJson", "View JSON", false)
                .setMinWidth(100)
                .setFlex(1)
                .editable(true)
                .renderCellComponent((params) => (
                    <div style={{ cursor: "pointer" }} className={`text-primary text-sm`}
                        onClick={() => {
                            const { businessAreaValue, invoiceId } = params?.row;
                            viewJsonHandler(businessAreaValue, invoiceId)
                        }}>View Json</div>
                )),
            new AGridColDef("action", "Resubmit", false)
                .setMinWidth(130)
                .setFlex(1)
                .editable(true)
                .renderCellComponent((params) => {
                    const status = params?.row?.thirdPartyStatus?.toUpperCase();
                    const businessArea = params?.row?.businessAreaValue;
                    const invoiceId = params?.row?.invoiceId;

                    return (
                        <AButton
                            variant="primary_filled"
                            onClick={(e) => { retryHandler(invoiceId, businessArea) }}
                            size="xs"
                            className="button_remove_left_margin"
                            disabled={status !== "FAILED"}
                        >
                            Resubmit
                        </AButton>
                    );
                }),
            new AGridColDef("createdOn", "Created On", true)
                .setMinWidth(220)
                .editable(true)
                .setFlex(0.7)
                .renderCellComponent((params) => {
                    const fomattedDate = `${moment(params?.value).format("YYYY-MM-DD HH:mm:ss")}`
                    return (
                        params?.value ? <div><Tooltip title={fomattedDate}>
                            <div className={`ellipsis-text-container`}>{fomattedDate}</div>
                        </Tooltip></div> : <div>-</div>
                    )
                }),
            new AGridColDef("createdBy", "Created By", true)
                .setMinWidth(150)
                .editable(true)
                .setFlex(0.7)
                .renderCellComponent((params) => {
                    return (
                        params?.value ? <div><Tooltip title={params?.value}>
                            <div className={`ellipsis-text-container`}>{params?.value}</div>
                        </Tooltip></div> : <div>-</div>
                    )
                }),
            new AGridColDef("updatedOn", "Updated On", true)
                .setMinWidth(220)
                .editable(true)
                .setFlex(0.7)
                .renderCellComponent((params) => {
                    return (
                        params?.value ? <div><Tooltip title={params?.value}>
                            <div className={`ellipsis-text-container`}>{params?.value}</div>
                        </Tooltip></div> : <div>-</div>
                    )
                }),
            new AGridColDef("updatedBy", "Updated By", true)
                .setMinWidth(150)
                .editable(true)
                .setFlex(0.7)
                .renderCellComponent((params) => {
                    return (
                        params?.value ? <div><Tooltip title={params?.value}>
                            <div className={`ellipsis-text-container`}>{params?.value}</div>
                        </Tooltip></div> : <div>-</div>
                    )
                }),
        ], [viewJsonHandler]);


        return (
            <>
                {isloading && <ALoader position="fixed" />}
                <div className="mt-3">
                    <ADataGrid
                        removeWrapperContainer
                        rowModesModel={rowModesModel}
                        rows={rowData || []}
                        columns={columns}
                        rowId={(row) => row?.id}
                        rowHeight={50}
                        rowCount={rowCount}
                        loading={false}
                        currentPage={currentPage}
                        nextButtonHandler={nextButtonHandler}
                        sx={{
                            ...gridStyles,
                        }}
                        autoHeight
                        paginationModel={{ page: currentPage, pageSize: currPageSize }}
                    />
                </div>
            </>
        );
    }
);

export default ListComponent;